// Module
var code = `<template>
  \${value | dateConverter} <mdc-icon click.delegate="openDatePicker()" style="vertical-align: middle;">event</mdc-icon>
</template>
`;
// Exports
export default code;